"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _StatusIcon = _interopRequireDefault(require("./StatusIcon.style"));

var _IconCheck = _interopRequireDefault(require("../../Icons/IconCheck"));

var _IconClose = _interopRequireDefault(require("../../Icons/IconClose"));

var _Loader = _interopRequireDefault(require("../../Loader"));

var getIconStyle = function getIconStyle(type, theme) {
  var color = theme.color;

  switch (type) {
    case 'success':
      return {
        bgColor: color.green,
        icon: "check"
      };

    case 'error':
      return {
        bgColor: color.red,
        icon: "close"
      };

    case 'info':
      return {
        bgColor: color.accent,
        icon: "check"
      };

    case 'warning':
      return {
        bgColor: color.yellow,
        icon: "check"
      };

    default:
      return null;
  }
};

var StatusIcon = function StatusIcon(_ref) {
  var type = _ref.type,
      theme = _ref.theme;

  if (type === 'loading') {
    return _react.default.createElement(_Loader.default, {
      width: 12,
      height: 12,
      style: {
        marginRight: '12px',
        verticalAlign: 'text-top'
      }
    });
  }

  var icon = getIconStyle(type, theme);

  if (!icon) {
    return null;
  }

  var iconColor = theme.color.white;
  return _react.default.createElement("div", {
    className: _StatusIcon.default.root(icon.bgColor, type)
  }, icon.icon === "close" ? _react.default.createElement(_IconClose.default, {
    className: _StatusIcon.default.icon(iconColor)
  }) : _react.default.createElement(_IconCheck.default, {
    className: _StatusIcon.default.icon(iconColor)
  }));
};

StatusIcon.defaultProps = {
  type: null
};
StatusIcon.prototype = {
  type: _propTypes.default.string
};

var _default = (0, _emotionTheming.withTheme)(StatusIcon);

exports.default = _default;